import Icon from './Icon';
import { Text } from './typography';
import styles from './AccessDeniedPage.module.scss';

// Generic "you're not allowed here" page body for routes that are real
// access boundaries (not just hidden nav links) — a page reachable by
// direct URL needs its own guard, since hiding the sidebar link alone does
// nothing to stop someone who already has, or guesses, the URL.
export default function AccessDeniedPage({ grantName }) {
  return (
    <div className={styles.container}>
      <Icon size="lg">lock</Icon>
      <Text weight="semiBold" noMargin>
        You don’t have access to this page
      </Text>
      <Text size="sm" color="secondary" noMargin>
        {grantName
          ? `Ask a company Admin to grant you "${grantName}" if you need it.`
          : 'Ask a company Admin if you need it.'}
      </Text>
    </div>
  );
}
